var SYSTEM: {
  MAX_DISCOUNT: {
    [key:string]: number
  }
} = {
  MAX_DISCOUNT: {}
};

export { SYSTEM };
